import {
  CHANGE_ACTIVE_ITEM_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
  // ----------------------- Protocol ----------------------------
  CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LOG,
  // ----------------------- Optic Fiber ----------------------------
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
  // ----------------------- Physical Medium DP ----------------------------
  CHANGE_ACTIVE_ITEM_DP_LIVELIST,
  CHANGE_ACTIVE_ITEM_DP_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_DP_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_DP_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_DP_LOG,
  // ----------------------- Config Route ----------------------------
  CHANGE_ROUTE
} from "actions/types";

// ---------------------------- Actions ----------------------------
export function tsExpertAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_TS_EXPERT,
    payload: { activeItem: "/" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

// ----------------------- Protocol ----------------------------
export function protocolResumeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME,
    payload: { activeItem: "/protocol-resume" }
  };
}

export function protocolLivelistAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST,
    payload: { activeItem: "/protocol-livelist" }
  };
}

export function protocolLiveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX,
    payload: { activeItem: "/protocol-livelist-matrix" }
  };
}

export function protocolGraphicTopologyAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY,
    payload: { activeItem: "/protocol-graphic-topology" }
  };
}

export function protocolLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LOG,
    payload: { activeItem: "/protocol-log" }
  };
}

// ----------------------- Optic Fiber ----------------------------
export function opticFiberAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
    payload: { activeItem: "/optic-fiber" }
  };
}

export function OpticFiberLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
    payload: { activeItem: "/optic-fiber-log" }
  };
}

// ----------------------- Physical Medium DP ----------------------------
export function dpLiveListAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DP_LIVELIST,
    payload: { activeItem: "/dp-live-list" }
  };
}

export function dpLiveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DP_LIVELIST_MATRIX,
    payload: { activeItem: "/dp-live-list-matrix" }
  };
}

export function dpOscilloscopeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DP_OSCILLOSCOPE,
    payload: { activeItem: "/dp-oscilloscope" }
  };
}

export function dpBarGraphAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DP_BAR_GRAPH,
    payload: { activeItem: "/dp-bar-graph" }
  };
}

export function dpLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DP_LOG,
    payload: { activeItem: "/dp-log" }
  };
}

// ----------------------- Solve Problem ----------------------------
export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: {
      solve: solve,
      problem: problem
    }
  };
}

// ----------------------- Change Route ----------------------------
export function changeRouteAction(currGenConfigComponent, currProtConfigComponent, currAnDPConfigComponent) {
  return {
    type: CHANGE_ROUTE,
    payload: {
      currGenConfigComponent: currGenConfigComponent,
      currProtConfigComponent: currProtConfigComponent,
      currAnDPConfigComponent: currAnDPConfigComponent
    }
  };
}